var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft2 = function SvgArrowLeft2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    fillOpacity: 0.8,
    fillRule: "evenodd",
    d: "m10.068 25.011-.01-.01-6.095-5.925a.53.53 0 0 1-.01-.755l.01-.01 6.106-5.942a.57.57 0 0 1 .788 0 .53.53 0 0 1 .01.754l-.01.01-5.132 4.997H34.01a.563.563 0 0 1 .57.555.56.56 0 0 1-.515.552l-.055.003H5.707l5.139 4.996a.53.53 0 0 1 .01.755l-.01.01a.57.57 0 0 1-.778.01"
  })));
};
export default SvgArrowLeft2;